module.exports = __webpack_public_path__ + "img/sw-ys32.9cd2e64c.jpg";